export enum SPECIAL_OFFER_PERMISSIONS {
  SPECIAL_OFFER_VIEW = 'SPECIAL_OFFERSVIEW',
  SPECIAL_OFFER_WRITE = 'SPECIAL_OFFERSWRITE',
}
